interface IDataLayerEvent {
    event: string;
    eventCategory: string;
    eventAction: string;
    eventLabel: string;
}

interface IWindow extends Window {
    dataLayer: IDataLayerEvent[];
}

declare const window: IWindow;

export function postDataLayerEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel: string
) {
    if (!window) return;

    const dataLayerEvent: IDataLayerEvent = {
        event: 'pblxContactFormSentEvent',
        eventCategory,
        eventAction,
        eventLabel,
    };

    window.parent.postMessage(dataLayerEvent, '*');
}
